/** Serie dei codici rapportino: `RI-2026-0142`. */
export const WORK_REPORT_CODE_PREFIX = 'RI';
/** Cifre del progressivo annuale del codice rapportino. */
export const WORK_REPORT_CODE_DIGITS = 4;
/** Minuti in un'ora: base del prezzo orario delle tariffe. */
export const MINUTES_PER_HOUR = 60;
/** Orario di sessione `HH:mm` (00:00–23:59). */
export const WORK_REPORT_TIME_REGEX = /^([01]\d|2[0-3]):[0-5]\d$/;
/** Durata massima di una sessione: un giorno lavorativo lungo. */
export const WORK_REPORT_MAX_SESSION_MINUTES = 24 * MINUTES_PER_HOUR;
/** Minimo e scaglione di una tariffa: da 0 a 8 ore. */
export const SERVICE_TARIFF_MAX_RULE_MINUTES = 8 * MINUTES_PER_HOUR;
/** Quantità delle righe: decimali per i materiali (metri di cavo). */
export const WORK_REPORT_QUANTITY_DECIMALS = 4;
export const WORK_REPORT_MIN_LINE_QUANTITY = 0.0001;
export const WORK_REPORT_MAX_LINE_QUANTITY = 1_000_000;
/** Tetto della pagina di lista: ogni rapportino porta sessioni e righe. */
export const WORK_REPORT_MAX_PAGE_SIZE = 200;
/** Minuti in un giorno: una sessione da/a con fine < inizio finisce il giorno dopo. */
export const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;
/**
 * Tetto di una sessione da/a a cavallo della mezzanotte (E3): fine < inizio
 * vale «giorno dopo» solo se la durata risultante resta entro 12 ore
 * (22:00 → 06:00 = 480 min); oltre è una fine prima dell'inizio (10:00 →
 * 09:00 non sono 23 ore di intervento, è un errore di digitazione).
 */
export const WORK_REPORT_MAX_OVERNIGHT_MINUTES = 12 * MINUTES_PER_HOUR;
/**
 * Tetto di una sessione a durata dichiarata: lo stesso della sessione da/a
 * a cavallo della mezzanotte (12 ore). Oltre è un errore di digitazione
 * (780 minuti non sono un intervento): FE, DTO e servizio lo applicano.
 */
export const WORK_REPORT_MAX_DURATION_MINUTES = WORK_REPORT_MAX_OVERNIGHT_MINUTES;
/**
 * Sessione da/a nello stesso giorno oltre 12 ore di lavoro (al netto della
 * pausa): AMMESSA — un turno lungo esiste — ma con un avviso nel form e
 * nell'anteprima dell'approvazione, perché quasi sempre è un orario
 * sbagliato. Le durate dichiarate e le notti oltre 12 ore restano rifiutate.
 */
export const WORK_REPORT_LONG_SESSION_WARNING_MINUTES = 12 * MINUTES_PER_HOUR;
/** Invio al cliente del PDF pubblicato: limiti di destinatario e messaggio. */
export const WORK_REPORT_SEND_MAX_EMAIL_LENGTH = 254;
export const WORK_REPORT_SEND_MAX_MESSAGE_LENGTH = 2000;
/** Tetto dell'approvazione multipla: stesso limite per DTO e webapp. */
export const WORK_REPORT_BULK_APPROVE_MAX = 50;
/** Decimali del costo orario dei tecnici (serializzazione `Decimal`). */
export const HOURLY_COST_DECIMALS = 2;
/**
 * Link al documento per il cliente («Portale clienti»): validità in giorni
 * scelta nelle Impostazioni, oppure nessuna scadenza (`null`, «finché
 * pubblicato»). Stessi limiti per DTO, servizio e webapp.
 */
export const WORK_REPORT_LINK_VALIDITY_MIN_DAYS = 1;
export const WORK_REPORT_LINK_VALIDITY_MAX_DAYS = 365;
/** Validità proposta a chi accende il portale (default dello schema). */
export const WORK_REPORT_LINK_DEFAULT_VALIDITY_DAYS = 30;
/** Rotta pubblica della webapp che apre il documento dal link dell'email. */
export const WORK_REPORT_PUBLIC_PATH = '/d/wr';
//# sourceMappingURL=work-reports.js.map